import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DownloadIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', ...sx }} {...props}>
      <path
        d="M19.25 19.25H2.75M16.5 10.0833L11 15.5833M11 15.5833L5.5 10.0833M11 15.5833V2.75"
        stroke={props.color === 'secondary' ? 'white' : 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default DownloadIcon;
